import React, { Component } from 'react';
import { Field, reduxForm } from 'redux-form';
import { Grid, Form } from 'semantic-ui-react';
import { ReimbursementRatesEnum } from 'Common/FieldEnum';
import { InputField } from 'Common/SemanticWrapper';
import { InputMode } from 'Common/FormEnum';
import { TitledCard } from 'Components';
import { REIMBURSEMENT_RATE_FORM } from 'Common/FormEnum';
import { StyledReduxFormError } from '../../../components';
import * as _ from 'lodash';

class ReimbursementRatesForm extends Component {
  render() {
    const { handleSubmit, error, isReadOnly } = this.props;

    return (
      <Form onSubmit={handleSubmit}>
        <Grid columns={3}>
          <Grid.Row>
            <Grid.Column>
              <div className="card-indent">
                <Field
                  label="Description"
                  name={ReimbursementRatesEnum.Description}
                  component={InputField}
                  type="text"
                  maxLength={30}
                  className="input--full"
                  readOnly={isReadOnly}
                />
                <StyledReduxFormError error={error} />
              </div>
            </Grid.Column>
          </Grid.Row>
        </Grid>
        <TitledCard title={'Federal Rates'}>
          <Grid columns={3}>
            <Grid.Row>
              <Grid.Column>
                <div className="field">
                  <label>Breakfast</label>
                </div>
              </Grid.Column>
              <Grid.Column>
                <div className="field">
                  <label>Lunch</label>
                </div>
              </Grid.Column>
              <Grid.Column>
                <div className="field">
                  <label>Supper</label>
                </div>
              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column>
                <Field
                  label={'Free'}
                  name={ReimbursementRatesEnum.FedBreakfastF}
                  component={InputField}
                  type="text"
                  className="input--full"
                  mode={InputMode.Decimal}
                  numericSize={[10, 4]}
                  readOnly={isReadOnly}
                />
              </Grid.Column>
              <Grid.Column>
                <Field
                  label={'Free'}
                  name={ReimbursementRatesEnum.FedLunchF}
                  component={InputField}
                  type="text"
                  className="input--full"
                  mode={InputMode.Decimal}
                  numericSize={[10, 4]}
                  readOnly={isReadOnly}
                />
              </Grid.Column>
              <Grid.Column>
                <Field
                  label={'Free'}
                  name={ReimbursementRatesEnum.PLS_SupperF}
                  component={InputField}
                  type="text"
                  className="input--full"
                  mode={InputMode.Decimal}
                  numericSize={[10, 4]}
                  readOnly={isReadOnly}
                />
              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column>
                <Field
                  label={'Reduced'}
                  name={ReimbursementRatesEnum.FedBreakfastR}
                  component={InputField}
                  type="text"
                  className="input--full"
                  mode={InputMode.Decimal}
                  numericSize={[10, 4]}
                  readOnly={isReadOnly}
                />
              </Grid.Column>
              <Grid.Column>
                <Field
                  label={'Reduced'}
                  name={ReimbursementRatesEnum.FedLunchR}
                  component={InputField}
                  type="text"
                  className="input--full"
                  mode={InputMode.Decimal}
                  numericSize={[10, 4]}
                  readOnly={isReadOnly}
                />
              </Grid.Column>
              <Grid.Column>
                <Field
                  label={'Reduced'}
                  name={ReimbursementRatesEnum.PLS_SupperR}
                  component={InputField}
                  type="text"
                  className="input--full"
                  mode={InputMode.Decimal}
                  numericSize={[10, 4]}
                  readOnly={isReadOnly}
                />
              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column>
                <Field
                  label={'Paid'}
                  name={ReimbursementRatesEnum.FedBreakfastP}
                  component={InputField}
                  type="text"
                  className="input--full"
                  mode={InputMode.Decimal}
                  numericSize={[10, 4]}
                  readOnly={isReadOnly}
                />
              </Grid.Column>
              <Grid.Column>
                <Field
                  label={'Paid'}
                  name={ReimbursementRatesEnum.FedLunchP}
                  component={InputField}
                  type="text"
                  className="input--full"
                  mode={InputMode.Decimal}
                  numericSize={[10, 4]}
                  readOnly={isReadOnly}
                />
              </Grid.Column>
              <Grid.Column>
                <Field
                  label={'Paid'}
                  name={ReimbursementRatesEnum.PLS_SupperP}
                  component={InputField}
                  type="text"
                  className="input--full"
                  mode={InputMode.Decimal}
                  numericSize={[10, 4]}
                  readOnly={isReadOnly}
                />
              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column>
                <div className="field">
                  <label>Severe Need Breakfast</label>
                </div>
              </Grid.Column>
              <Grid.Column>
                <div className="field">
                  <label>After School Snacks</label>
                </div>
              </Grid.Column>
              <Grid.Column>
                <div className="field">
                  <label>Special Milk</label>
                </div>
              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column>
                <Field
                  label={'Free'}
                  name={ReimbursementRatesEnum.FedSevereF}
                  component={InputField}
                  type="text"
                  className="input--full"
                  mode={InputMode.Decimal}
                  numericSize={[10, 4]}
                  readOnly={isReadOnly}
                />
              </Grid.Column>
              <Grid.Column>
                <Field
                  label={'Free'}
                  name={ReimbursementRatesEnum.FedSnackF}
                  component={InputField}
                  type="text"
                  className="input--full"
                  mode={InputMode.Decimal}
                  numericSize={[10, 4]}
                  readOnly={isReadOnly}
                />
              </Grid.Column>
              <Grid.Column>
                <Field
                  label={'Free'}
                  name={ReimbursementRatesEnum.FedMilkF}
                  component={InputField}
                  type="text"
                  className="input--full"
                  mode={InputMode.Decimal}
                  numericSize={[10, 4]}
                  readOnly={isReadOnly}
                />
              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column>
                <Field
                  label={'Reduced'}
                  name={ReimbursementRatesEnum.FedSevereR}
                  component={InputField}
                  type="text"
                  className="input--full"
                  mode={InputMode.Decimal}
                  numericSize={[10, 4]}
                  readOnly={isReadOnly}
                />
              </Grid.Column>
              <Grid.Column>
                <Field
                  label={'Reduced'}
                  name={ReimbursementRatesEnum.FedSnackR}
                  component={InputField}
                  type="text"
                  className="input--full"
                  mode={InputMode.Decimal}
                  numericSize={[10, 4]}
                  readOnly={isReadOnly}
                />
              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column>
                <Field
                  label={'Paid'}
                  name={ReimbursementRatesEnum.FedSevereP}
                  component={InputField}
                  type="text"
                  className="input--full"
                  mode={InputMode.Decimal}
                  numericSize={[10, 4]}
                  readOnly={isReadOnly}
                />
              </Grid.Column>
              <Grid.Column>
                <Field
                  label={'Paid'}
                  name={ReimbursementRatesEnum.FedSnackP}
                  component={InputField}
                  type="text"
                  className="input--full"
                  mode={InputMode.Decimal}
                  numericSize={[10, 4]}
                  readOnly={isReadOnly}
                />
              </Grid.Column>
              <Grid.Column>
                <Field
                  label={'Paid'}
                  name={ReimbursementRatesEnum.FedMilkP}
                  component={InputField}
                  type="text"
                  className="input--full"
                  mode={InputMode.Decimal}
                  numericSize={[10, 4]}
                  readOnly={isReadOnly}
                />
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </TitledCard>
        <TitledCard title={'State Rates'}>
          <Grid columns={3}>
            <Grid.Row>
              <Grid.Column>
                <div className="field">
                  <label>Breakfast</label>
                </div>
              </Grid.Column>
              <Grid.Column>
                <div className="field">
                  <label>Lunch</label>
                </div>
              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column>
                <Field
                  label={'Free'}
                  name={ReimbursementRatesEnum.StateBreakfastF}
                  component={InputField}
                  type="text"
                  className="input--full"
                  mode={InputMode.Decimal}
                  numericSize={[10, 4]}
                  readOnly={isReadOnly}
                />
              </Grid.Column>
              <Grid.Column>
                <Field
                  label={'Free'}
                  name={ReimbursementRatesEnum.StateLunchF}
                  component={InputField}
                  type="text"
                  className="input--full"
                  mode={InputMode.Decimal}
                  numericSize={[10, 4]}
                  readOnly={isReadOnly}
                />
              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column>
                <Field
                  label={'Reduced'}
                  name={ReimbursementRatesEnum.StateBreakfastR}
                  component={InputField}
                  type="text"
                  className="input--full"
                  mode={InputMode.Decimal}
                  numericSize={[10, 4]}
                  readOnly={isReadOnly}
                />
              </Grid.Column>
              <Grid.Column>
                <Field
                  label={'Reduced'}
                  name={ReimbursementRatesEnum.StateLunchR}
                  component={InputField}
                  type="text"
                  className="input--full"
                  mode={InputMode.Decimal}
                  numericSize={[10, 4]}
                  readOnly={isReadOnly}
                />
              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column>
                <Field
                  label={'Paid'}
                  name={ReimbursementRatesEnum.StateBreakfastP}
                  component={InputField}
                  type="text"
                  className="input--full"
                  mode={InputMode.Decimal}
                  numericSize={[10, 4]}
                  readOnly={isReadOnly}
                />
              </Grid.Column>
              <Grid.Column>
                <Field
                  label={'Paid'}
                  name={ReimbursementRatesEnum.StateLunchP}
                  component={InputField}
                  type="text"
                  className="input--full"
                  mode={InputMode.Decimal}
                  numericSize={[10, 4]}
                  readOnly={isReadOnly}
                />
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </TitledCard>
      </Form>
    );
  }
}

const validate = (values, props) => {
  const errors = {};

  if (
    !values[ReimbursementRatesEnum.Description] ||
    _.trim(values[ReimbursementRatesEnum.Description]).length === 0
  ) {
    errors[ReimbursementRatesEnum.Description] = 'Description Required';
  }

  return errors;
};

export default reduxForm({
  validate,
  form: REIMBURSEMENT_RATE_FORM,
  enableReinitialize: true,
})(ReimbursementRatesForm);



// WEBPACK FOOTER //
// ./src/pages/reimbursementrates/components/ReimbursementRatesForm.js